import React from 'react';
import { motion } from 'framer-motion';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/tSS9B7c7kM8oqzoyJ5ok3c/mira,_haceme_esta_202603231026.png';
export function HeroSection() {
  return <section className="w-full bg-white leading-[0] p-0 m-0" data-id="element-181">
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.8
    }} data-id="element-182">
        <img src={HERO_IMAGE} alt="Boba Professional Hero" className="w-full h-auto object-contain block m-0 p-0" data-id="element-183" />
      </motion.div>
    </section>;
}